export default function MySQL_INSTR() {
  return (
    <div>
      <h2>MySQL_INSTR</h2>    </div>
  );
}